/**
 * What the contact form starts with when it is opened from a search box (#919, D10).
 *
 * The event's "Add Contacts" dialog searches by name or email; when nothing matches, "Create New Contact" opens the form
 * with what was typed already in it, so the owner does not type it twice. Text with an "@" is an email; anything else is a
 * name (the first word is the first name, the rest the last name). Under two characters, the search has not run: no seed.
 */
export function contactSeedFromSearch(search) {
    const text = String(search || '').trim();
    if (text.length < 2) return null;
    if (text.includes('@')) return { email: text };
    const [first, ...rest] = text.split(/\s+/);
    return rest.length ? { first_name: first, last_name: rest.join(' ') } : { first_name: first };
}
